
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_1ab4i_13",
  "arrow-outer": "awsui_arrow-outer_xjuzf_1ab4i_17",
  "arrow-inner": "awsui_arrow-inner_xjuzf_1ab4i_17",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_1ab4i_59",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_1ab4i_59",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_1ab4i_62",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_1ab4i_62",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_1ab4i_65",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_1ab4i_65",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_1ab4i_65",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_1ab4i_65",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_1ab4i_68",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_1ab4i_68",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_1ab4i_68",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_1ab4i_68",
  "arrow-variant-info": "awsui_arrow-variant-info_xjuzf_1ab4i_72",
  "body": "awsui_body_xjuzf_1ab4i_83",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_1ab4i_119",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_1ab4i_122",
  "has-dismiss": "awsui_has-dismiss_xjuzf_1ab4i_127",
  "dismiss": "awsui_dismiss_xjuzf_1ab4i_132",
  "dismiss-control": "awsui_dismiss-control_xjuzf_1ab4i_140",
  "header-row": "awsui_header-row_xjuzf_1ab4i_144",
  "header": "awsui_header_xjuzf_1ab4i_144",
  "content": "awsui_content_xjuzf_1ab4i_173",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_1ab4i_182",
  "container": "awsui_container_xjuzf_1ab4i_190",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_1ab4i_201",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_1ab4i_201",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_1ab4i_201",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_1ab4i_206",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_1ab4i_206",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_1ab4i_206",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_1ab4i_211",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_1ab4i_211",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_1ab4i_216",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_1ab4i_216",
  "container-body": "awsui_container-body_xjuzf_1ab4i_222",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_1ab4i_262",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_1ab4i_267",
  "fixed-width": "awsui_fixed-width_xjuzf_1ab4i_270",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_1ab4i_274",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_1ab4i_281",
  "container-arrow": "awsui_container-arrow_xjuzf_1ab4i_201",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_1ab4i_331",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_1ab4i_1",
  "refresh": "awsui_refresh_xjuzf_1ab4i_385",
  "root": "awsui_root_xjuzf_1ab4i_412",
  "no-wrap": "awsui_no-wrap_xjuzf_1ab4i_444",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_1ab4i_447",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_1ab4i_447",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_1ab4i_447",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_1ab4i_469",
  "trigger": "awsui_trigger_xjuzf_1ab4i_447",
  "in-inline-token": "awsui_in-inline-token_xjuzf_1ab4i_511",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_1ab4i_559",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_1ab4i_563",
  "hover-area": "awsui_hover-area_xjuzf_1ab4i_567"
};
  